import { useEffect } from "react";
import { useMotionValue } from "framer-motion";

import { safeWindow } from "../utils/helpers/ssr";
import { sectionRhythm } from "../../theme";

const HEADER_MOBILE = sectionRhythm.headerHeight.mobile;
const HEADER_DESKTOP = sectionRhythm.headerHeight.desktop;
const TABLET_MQ = `(min-width: ${sectionRhythm.breakpoint})`;

const useTitleToTopProgress = (titleRef) => {
  const progress = useMotionValue(0);

  useEffect(() => {
    const update = () => {
      const el = titleRef?.current;
      if (!el || typeof safeWindow.innerHeight !== "number") {
        return;
      }

      const rect = el.getBoundingClientRect();
      const vh = safeWindow.innerHeight || 1;
      const isDesktop =
        typeof safeWindow.matchMedia === "function" &&
        safeWindow.matchMedia(TABLET_MQ).matches;
      const headerH = isDesktop ? HEADER_DESKTOP : HEADER_MOBILE;
      const endTop = headerH + 8;
      const startTop = vh / 2 - rect.height / 2;
      const travel = Math.max(startTop - endTop, 1);
      const raw = (startTop - rect.top) / travel;
      progress.set(Math.min(Math.max(raw, 0), 1));
    };

    update();
    safeWindow.addEventListener?.("scroll", update, { passive: true });
    safeWindow.addEventListener?.("resize", update);

    return () => {
      safeWindow.removeEventListener?.("scroll", update);
      safeWindow.removeEventListener?.("resize", update);
    };
  }, [titleRef, progress]);

  return progress;
};

export default useTitleToTopProgress;
